import { registerHandler } from 'nike-re-framejs';
import { Set } from 'immutable';

import { userFavoritesUpdated } from '@/account/handlers';
import { defaultMiddlewares } from '@/common/util';
import { fireGAEvent } from '@/analytics';
import i18n from '@i18n';
import { removeKey } from '@/services/localStorage';
import PopupNg from '@/ui/PopupNg';
import {
    addFavouriteCasinoVegasGamesToModel,
    addFavouriteCasinoVegasGamesToServer,
    addFavouriteItemToModel,
    addFavouriteItemToServer,
    loadFavoritesMarketsFromLS,
    loadFavoritesMenuItemsFromLS,
    removeFavouriteCasinoVegasGamesFromModel,
    removeFavouriteCasinoVegasGamesFromServer,
    removeFavouriteItemFromModel,
    removeFavouriteItemFromServer
} from './api';

export const userFavouritePath = ['account', 'userFavourites'];

registerHandler('favourite.item.toggle', defaultMiddlewares, (db, [boxId]) => {
    const isFavorite = db.getIn([...userFavouritePath, 'menuItems'], Set()).has(boxId);
    const loggedIn = db.get('loggedIn');

    if (!loggedIn) {
        PopupNg.dispatcher.open('dialog/message', { bodyText: i18n('favourite.notloggedin') });
        return db;
    }
    if (isFavorite) {
        fireGAEvent(db.getIn(['route']), 'Odobranie sutaze z oblubenych', 'Oblubene');
        removeFavouriteItemFromServer(boxId);
        return removeFavouriteItemFromModel(db, boxId);
    }

    fireGAEvent(db.getIn(['route']), 'Pridanie sutaze z oblubenych', 'Oblubene');
    addFavouriteItemToServer(boxId);
    return addFavouriteItemToModel(db, boxId);
});

registerHandler('favourite.casinoVegasGames.toggle', defaultMiddlewares, (db, [gameId]) => {
    const isFavorite = db.getIn([...userFavouritePath, 'casinoVegasGames'], []).includes(gameId);
    const loggedIn = db.get('loggedIn');

    if (!loggedIn) {
        PopupNg.dispatcher.open('dialog/login4action', { bodyText: i18n('casino.favorite.notLoggedMessage') });
        return db;
    }
    if (isFavorite) {
        fireGAEvent(db.getIn(['route']), 'Odobranie kasino hry z oblubenych', 'Oblubene');
        removeFavouriteCasinoVegasGamesFromServer(gameId);
        return removeFavouriteCasinoVegasGamesFromModel(db, gameId);
    }

    fireGAEvent(db.getIn(['route']), 'Pridanie kasino hry do oblubenych', 'Oblubene');
    addFavouriteCasinoVegasGamesToServer(gameId);
    return addFavouriteCasinoVegasGamesToModel(db, gameId);
});

registerHandler('favourites.updated', defaultMiddlewares, (db, [data]) =>
    db.update(userFavoritesUpdated(data.favourite))
);

export function initFavorites(db) {
    const loggedIn = db.get('loggedIn');
    removeKey('nikeOneFavoriteBoxes');
    removeKey('nikeOneFavoritesOrder');
    removeKey('nikeOneFavoriteMarkets');
    if (loggedIn) {
        return db;
    }
    //niesom prihlaseny => tak nasetujem do modelu oblubene z localstorage
    return db
        .setIn([...userFavouritePath, 'menuItems'], loadFavoritesMenuItemsFromLS())
        .setIn([...userFavouritePath, 'markets'], loadFavoritesMarketsFromLS());
}
